// totalPrice is the ticket price after discount, before platform fees.
// Older participants only have sum; keep their PDFs compatible.
export function getTicketPdfAmount(ticket) {
  const gross = ticket?.totalPrice;
  if (gross !== undefined && gross !== null && gross !== "" && Number.isFinite(Number(gross))) {
    return Number(gross);
  }
  return Number(ticket?.sum) || 0;
}

export function splitTicketsForPdf(tickets = []) {
  return tickets.flatMap((ticket) => {
    const quantity = Number(ticket.number);
    if (!Number.isInteger(quantity) || quantity <= 0) return [];
    const grossCents = Math.round(getTicketPdfAmount(ticket) * 100);
    const netCents = Math.round((Number(ticket.sum) || 0) * 100);
    const share = (cents, index) =>
      (Math.round(cents * (index + 1) / quantity) - Math.round(cents * index / quantity)) / 100;
    return Array.from({ length: quantity }, (_, index) => ({
      ...ticket,
      number: 1,
      totalPrice: share(grossCents, index),
      sum: share(netCents, index),
    }));
  });
}
